import React from "react";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import EmailTemplatesPage from "../placement/EmailTemplatesPage";

export default function EmployeeEmailTemplatesPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <EmployeeNavbar />
      <EmailTemplatesPage />
    </div>
  );
}
